import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon May 20 2019
 * @author SKu
 */
import { Utils, ValidationError, ValidationLevel, ValidationResultWrapper } from '@logio/common-be-fe';
import moment from 'moment';
import * as React from 'react';
import { InputValidated } from '../../../../inputs/Input';
import CellEditor from './CellEditor';
/**
 * Number editor for the sellout final price column
 * @extends CellEditor
 */

export var ReleaseSelloutFinalPriceEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(ReleaseSelloutFinalPriceEditor, _CellEditor);

  function ReleaseSelloutFinalPriceEditor(props) {
    var _this;

    _classCallCheck(this, ReleaseSelloutFinalPriceEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseSelloutFinalPriceEditor).call(this, props));
    /** Valid validation result used to omit NOT_VALID state from validationResult object(alerts) */

    _this.validValidationResult = {
      validationResult: new ValidationResultWrapper()
    };
    /** Handles changes of the input element */

    _this.onChange = function (event) {
      var newValue = event.target.value;

      if (newValue !== '0') {
        _this.updateValue(Object.assign(Object.assign({}, _this.state.value), {
          value: newValue,
          validationResult: _this.validValidationResult
        }));
      }
    };
    /** LOG-2079 - Select all on focus */


    _this.onFocus = function (event) {
      return event.target.select();
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(InputValidated, {
        className: "ag-sellout-final-price-editor",
        validationError: _this.validation,
        type: "number",
        value: _this.state.value.value || '',
        onChange: _this.onChange,
        onFocus: _this.onFocus,
        tiny: true
      }));
    };

    return _this;
  }
  /** Method is overwritten to set default valid  */


  _createClass(ReleaseSelloutFinalPriceEditor, [{
    key: "initialState",
    value: function initialState() {
      var data = this.props.value;
      /** If values do not exists, will be created fake values to pass validator */
      // Empty string from bulk renderer

      if (Utils.isValueMissing(data) || Utils.isEmptyString(data)) {
        data = {
          priceZoneId: '',
          validFrom: moment(),
          validationResult: ValidationResultWrapper.EMPTY
        };
      }

      return {
        value: Object.assign(Object.assign({}, data), {
          value: data.valueRounded || data.value,
          validationResult: ValidationResultWrapper.EMPTY
        }),
        validationError: null
      };
    }
    /** Validates input */

  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      // Add char (number) to the edited input element if pressed over the cell
      if (this.props.charPress && Number(this.props.charPress).toString() === this.props.charPress) {
        this.updateValue(Object.assign(Object.assign({}, this.state.value), {
          value: "".concat(this.state.value.value).concat(this.props.charPress),
          validationResult: this.validValidationResult
        }));
      }
    }
    /**
     * AgGrid method - Should return the final value to the grid, the result of the editing
     */

  }, {
    key: "getValue",
    value: function getValue() {
      var _this2 = this;

      var validationResult = this.colDef.schema.validate(this.state.value, ValidationLevel.Fast); // const isBulk = this.props.context.store.showBulkRow && this.props.rowIndex === 0 && this.props.value === '';
      // const isBulk = this.props.context.store.showBulkRow && this.props.node.rowPinned === 'top';

      var isBulk = this.props.node.rowIndex === 0 && this.props.node.rowPinned === 'top';
      var bulkAction = this.colDef.bulkFunc;
      var actionFunc = isBulk && bulkAction ? bulkAction : this.colDef.action;
      var valueHasBeenChanged = !this.props.value || !this.props.value.value || (this.props.value.valueRounded || this.props.value.value) !== this.state.value.value; // LOG-5494

      var colId = this.props.column.getId();

      if (actionFunc && validationResult.valid && validationResult.get() !== this.props.value && valueHasBeenChanged) {
        this.props.eGridCell.classList.remove('is-loading-ok', 'is-loading-error');
        this.props.eGridCell.classList.add('is-loading'); // Get validated value

        var validatedValue = validationResult.get(); // Set empty string value to null

        if (Utils.isString(validatedValue) && !validatedValue.length) {
          validatedValue = null;
        } // Call the backend to update the value


        actionFunc(this.props.node.id, colId, validatedValue).then(function (value) {
          _this2.props.eGridCell.classList.replace('is-loading', 'is-loading-ok');
        }, function (error) {
          _this2.props.eGridCell.classList.replace('is-loading', 'is-loading-error');
        }).then(function () {
          if (isBulk) {
            // FIXME: we should update just all cells in specific column
            _this2.props.api.redrawRows();
          }

          _this2.setUpdatingDone(); // LOG-3758

        });

        if (isBulk) {
          // we need to update all cells in specific column
          this.props.api.forEachNode(function (node) {
            return node.setDataValue(colId, validatedValue);
          });
        }

        return validatedValue;
      } // If the value is successfully validated, return the parsed one...

      /* else */
      else if (validationResult.valid) {
          return validationResult.get();
        } // ...otherwise return the original one


      return this.props.value;
    }
  }, {
    key: "validation",
    get: function get() {
      return this.state.value.value <= 0 || Utils.isValueMissing(this.state.value.value) ? new ValidationError('err-less-or-equal-zero') : null;
    }
  }]);

  return ReleaseSelloutFinalPriceEditor;
}(CellEditor);